module.exports = __webpack_public_path__ + "img/atmbersama.ff172855.jpg";